var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTentang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_669_1236",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.5C9.25 5.91421 8.91421 6.25 8.5 6.25C8.08579 6.25 7.75 5.91421 7.75 5.5C7.75 5.08579 8.08579 4.75 8.5 4.75C8.91421 4.75 9.25 5.08579 9.25 5.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.5C9.25 5.91421 8.91421 6.25 8.5 6.25C8.08579 6.25 7.75 5.91421 7.75 5.5C7.75 5.08579 8.08579 4.75 8.5 4.75C8.91421 4.75 9.25 5.08579 9.25 5.5Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 5.5C7.75 5.08579 8.08579 4.75 8.5 4.75V7.75C9.74264 7.75 10.75 6.74264 10.75 5.5H7.75ZM8.5 4.75C8.91421 4.75 9.25 5.08579 9.25 5.5H6.25C6.25 6.74264 7.25736 7.75 8.5 7.75V4.75ZM9.25 5.5C9.25 5.91421 8.91421 6.25 8.5 6.25V3.25C7.25736 3.25 6.25 4.25736 6.25 5.5H9.25ZM8.5 6.25C8.08579 6.25 7.75 5.91421 7.75 5.5H10.75C10.75 4.25736 9.74264 3.25 8.5 3.25V6.25Z",
    fill: "#C4C4C4",
    mask: "url(#path-1-inside-1_669_1236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.75V12.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentang);
export default __webpack_public_path__ + "static/media/tentang.e28a27bc15f0745a7743a12884c76290.svg";
export { ForwardRef as ReactComponent };